import { useThemeQueries } from "../../../../../../theme";
import { DefaultModal } from "../../../../default-modal";
import { AdicionarAplicacaoProd } from "./adicionar-aplicacao-prod/adicionar-aplicacao-prod";

type Props = {
  openned: boolean;
}

export const ModalAdcAplicacaoAdminProd = ({ openned }: Props) => {
  const { isMobile } = useThemeQueries();


  return (
    <DefaultModal
      minWidth={isMobile ? '0' : "600px"}
      open={openned || false}
      variant={"temporary"}
      anchor="right"
    >
      <AdicionarAplicacaoProd />
    </DefaultModal>
  );
};
